export enum SESSION_STORAGE_KEY {
  BUILD_VERSION = 'tsxBuildVersion',
}

export const getSessionStorage = (key: SESSION_STORAGE_KEY): string | undefined => {
  try {
    return window?.sessionStorage?.getItem(key) || undefined;
  } catch {
    return undefined;
  }
};

export const setSessionStorage = (key: SESSION_STORAGE_KEY, value: string): void => {
  try {
    window?.sessionStorage?.setItem(key, value);
  } catch {
    // storage unavailable in private mode; degrade to a no-op
  }
};
